// extracted by mini-css-extract-plugin
export default {"container":"AJ-z","dimension":"BJ-z","dimensionLabels":"CJ-z"};